import { getUserPhoneNumber } from './custom-operations/queries/getUser-phone-number';
import { getUserAccounts } from './custom-operations/queries/getUser-accounts';
import { getUserAllDetails } from './custom-operations/queries/getUser-all-details';
import { getUserBrokers } from './custom-operations/queries/getUser-brokers';
import { getUserName } from './custom-operations/queries/getUser-name';
import { getUserNeedTransactionSecondConfirmation } from './custom-operations/queries/getUser-need-transaction-second-confirmation';
import { portfolio_fundamentals } from './custom-operations/queries/portfolio_fundamentals';
import { sum_portfolioLastUpdate } from './custom-operations/queries/sum_portfolio-last-update';
import { accept_message } from './generated-operations/mutations/accept_message';
import { cancel_exchange_order } from './generated-operations/mutations/cancel_exchange_order';
import { cancel_exchange_order_confirm } from './generated-operations/mutations/cancel_exchange_order_confirm';
import { confirm_password_update } from './generated-operations/mutations/confirm_password_update';
import { create_exchange_order } from './generated-operations/mutations/create_exchange_order';
import { create_exchange_order_confirm } from './generated-operations/mutations/create_exchange_order_confirm';
import { logout } from './generated-operations/mutations/logout';
import { read_message } from './generated-operations/mutations/read_message';
import { read_notification } from './generated-operations/mutations/read_notification';
import { update_user_password } from './generated-operations/mutations/update_user_password';
import { accept_terms_of_use } from './generated-operations/mutations/accept_terms_of_use';
import { update_user_password_with_confirm } from './generated-operations/mutations/update_user_password_with_confirm';
import { update_user_timeout } from './generated-operations/mutations/update_user_timeout';
import { getUser } from './generated-operations/queries/getUser';
import { get_account_balance } from './generated-operations/queries/get_account_balance';
import { get_currencies } from './generated-operations/queries/get_currencies';
import { get_currency_conversion } from './generated-operations/queries/get_currency_conversion';
import { get_currency_conversions } from './generated-operations/queries/get_currency_conversions';
import { get_exchange_order } from './generated-operations/queries/get_exchange_order';
import { get_exchange_orders } from './generated-operations/queries/get_exchange_orders';
import { get_message } from './generated-operations/queries/get_message';
import { get_messages } from './generated-operations/queries/get_messages';
import { get_money_transfer } from './generated-operations/queries/get_money_transfer';
import { get_money_transfers } from './generated-operations/queries/get_money_transfers';
import { get_money_transition } from './generated-operations/queries/get_money_transition';
import { get_money_transitions } from './generated-operations/queries/get_money_transitions';
import { get_notifications } from './generated-operations/queries/get_notifications';
import { get_securities } from './generated-operations/queries/get_securities';
import { get_security_amount } from './generated-operations/queries/get_security_amount';
import { get_security_transfer } from './generated-operations/queries/get_security_transfer';
import { get_security_transfers } from './generated-operations/queries/get_security_transfers';
import { get_security_transition } from './generated-operations/queries/get_security_transition';
import { get_security_transitions } from './generated-operations/queries/get_security_transitions';
import { get_unit_order } from './generated-operations/queries/get_unit_order';
import { get_unit_orders } from './generated-operations/queries/get_unit_orders';
import { get_unread_messages_count } from './generated-operations/queries/get_unread_messages_count';
import { get_unread_notifications_count } from './generated-operations/queries/get_unread_notifications_count';
import { get_valid_trading_days } from './generated-operations/queries/get_valid_trading_days';
import { login_first } from './generated-operations/queries/login_first';
import { login_second } from './generated-operations/queries/login_second';
import { portfolio_history_graph } from './generated-operations/queries/portfolio_history_graph';
import { sum_portfolio } from './generated-operations/queries/sum_portfolio';
import { token_validate } from './generated-operations/queries/token_validate';
import { validate_password } from './generated-operations/queries/validate_password';
import { auto_read_notification } from './generated-operations/subscriptions/auto_read_notification';
import { message_read } from './generated-operations/subscriptions/message_read';
import { message_unread_count } from './generated-operations/subscriptions/message_unread_count';
import { new_currency_conversion } from './generated-operations/subscriptions/new_currency_conversion';
import { new_exchange_order } from './generated-operations/subscriptions/new_exchange_order';
import { new_message } from './generated-operations/subscriptions/new_message';
import { new_money_transfer } from './generated-operations/subscriptions/new_money_transfer';
import { new_money_transition } from './generated-operations/subscriptions/new_money_transition';
import { new_notification } from './generated-operations/subscriptions/new_notification';
import { new_security_transfer } from './generated-operations/subscriptions/new_security_transfer';
import { new_security_transition } from './generated-operations/subscriptions/new_security_transition';
import { new_token } from './generated-operations/subscriptions/new_token';
import { new_unit_order } from './generated-operations/subscriptions/new_unit_order';
import { notification_read } from './generated-operations/subscriptions/notification_read';
import { notification_unread_count } from './generated-operations/subscriptions/notification_unread_count';
import { sum_portfolio as sum_portfolio_subscription } from './generated-operations/subscriptions/sum_portfolio';
import { update_currency_conversion } from './generated-operations/subscriptions/update_currency_conversion';
import { update_exchange_order } from './generated-operations/subscriptions/update_exchange_order';
import { update_money_transfer } from './generated-operations/subscriptions/update_money_transfer';
import { update_money_transition } from './generated-operations/subscriptions/update_money_transition';
import { update_security_transfer } from './generated-operations/subscriptions/update_security_transfer';
import { update_security_transition } from './generated-operations/subscriptions/update_security_transition';
import { update_unit_order } from './generated-operations/subscriptions/update_unit_order';
import {
  AuthFirst,
  AuthSecond,
  CreateExchangeOrder,
  CurrencyListType,
  CurrencyType,
  HistoryQuery,
  ListingFilter,
  ListingOrder,
  OrderingDirection,
  OrderingType,
  Paginator,
  SecurityListType,
  SecurityType,
  Status,
  UpdateUserPassword,
} from './types/types.d';
import { update_user_language } from './generated-operations/mutations/update_user_language';

export const GraphqlOperations = {
  queries: {
    login_first: {
      queryString: login_first,
      createVars: (uid: string, password: string): { input: AuthFirst } => ({
        input: { uid, password },
      }),
    },
    login_second: {
      queryString: login_second,
      createVars: (first_token: string, secret: string): { input: AuthSecond } => ({
        input: { first_token, secret },
      }),
    },
    token_validate: {
      queryString: token_validate,
    },
    getUser: {
      queryString: getUser,
    },
    getUserAllDetails: {
      queryString: getUserAllDetails,
    },
    getUserName: {
      queryString: getUserName,
    },
    getUserAccounts: {
      queryString: getUserAccounts,
    },
    getUserPhoneNumber: {
      queryString: getUserPhoneNumber,
    },
    getUserBrokers: {
      queryString: getUserBrokers,
    },
    getUserNeedTransactionSecondConfirmation: {
      queryString: getUserNeedTransactionSecondConfirmation,
    },
    get_notifications: {
      queryString: get_notifications,
      createVars: (page: number, per_page: number): { paginator: Paginator } => ({
        paginator: { page, per_page },
      }),
    },
    get_unread_notifications_count: {
      queryString: get_unread_notifications_count,
    },
    get_messages: {
      queryString: get_messages,
      createVars: (page: number, per_page: number): { paginator: Paginator } => ({
        paginator: { page, per_page },
      }),
    },
    get_unread_messages_count: {
      queryString: get_unread_messages_count,
    },
    get_message: {
      queryString: get_message,
      createVars: (id: number): { id: number } => ({
        id,
      }),
    },
    validate_password: {
      queryString: validate_password,
      createVars: (old_password: string): { old_password: string } => ({
        old_password,
      }),
    },
    sum_portfolio: {
      queryString: sum_portfolio,
    },
    sum_portfolioLastUpdate: {
      queryString: sum_portfolioLastUpdate,
    },
    portfolio_fundamentals: {
      queryString: portfolio_fundamentals,
      createVars: (account: string): { account: string } => ({
        account,
      }),
    },
    portfolio_history_graph: {
      queryString: portfolio_history_graph,
      createVars: (account: string, range: number): { input: HistoryQuery } => ({
        input: { account, range },
      }),
    },
    get_account_balance: {
      queryString: get_account_balance,
      createVars: (account: string, currency: string): { account: string; currency: string } => ({
        account,
        currency,
      }),
    },
    get_security_amount: {
      queryString: get_security_amount,
      createVars: (account: string, security: string): { account: string; security: string } => ({
        account,
        security,
      }),
    },
    get_exchange_orders: {
      queryString: get_exchange_orders,
      createVars: (
        page: number,
        per_page: number,
        type: OrderingType,
        direction: OrderingDirection,
        status: Status | 'all',
        ids: string[],
        account: string,
      ): {
        paginator: Paginator;
        order: ListingOrder;
        filter: ListingFilter;
      } => ({
        paginator: { page, per_page },
        order: { type, direction },
        filter: { status: status === 'all' ? [] : [status], ids, account },
      }),
    },
    get_exchange_order: {
      queryString: get_exchange_order,
      createVars: (id: number): { id: number } => ({
        id,
      }),
    },
    get_securities: {
      queryString: get_securities,
      createVars: (
        type: SecurityType,
        list_type: SecurityListType,
        account: string,
      ): { type: SecurityType; list_type: SecurityListType; account: string } => ({
        type,
        list_type,
        account,
      }),
    },
    get_valid_trading_days: {
      queryString: get_valid_trading_days,
    },
    get_unit_orders: {
      queryString: get_unit_orders,
      createVars: (
        page: number,
        per_page: number,
        type: OrderingType,
        direction: OrderingDirection,
        status: Status | 'all',
        ids: string[],
        account: string,
      ): {
        paginator: Paginator;
        order: ListingOrder;
        filter: ListingFilter;
      } => ({
        paginator: { page, per_page },
        order: { type, direction },
        filter: { status: status === 'all' ? [] : [status], ids, account },
      }),
    },
    get_unit_order: {
      queryString: get_unit_order,
      createVars: (id: string): { id: string } => ({
        id,
      }),
    },
    get_money_transitions: {
      queryString: get_money_transitions,
      createVars: (
        page: number,
        per_page: number,
        type: OrderingType,
        direction: OrderingDirection,
        status: Status | 'all',
        ids: string[],
        account: string,
      ): {
        paginator: Paginator;
        order: ListingOrder;
        filter: ListingFilter;
      } => ({
        paginator: { page, per_page },
        order: { type, direction },
        filter: { status: status === 'all' ? [] : [status], ids, account },
      }),
    },
    get_money_transition: {
      queryString: get_money_transition,
      createVars: (id: string): { id: string } => ({
        id,
      }),
    },
    get_currencies: {
      queryString: get_currencies,
      createVars: (
        type: CurrencyType,
        list_type: CurrencyListType,
        account: string,
      ): { type: CurrencyType; list_type: CurrencyListType; account: string } => ({
        type,
        list_type,
        account,
      }),
    },
    get_security_transitions: {
      queryString: get_security_transitions,
      createVars: (
        page: number,
        per_page: number,
        type: OrderingType,
        direction: OrderingDirection,
        status: Status | 'all',
        ids: string[],
        account: string,
      ): {
        paginator: Paginator;
        order: ListingOrder;
        filter: ListingFilter;
      } => ({
        paginator: { page, per_page },
        order: { type, direction },
        filter: { status: status === 'all' ? [] : [status], ids, account },
      }),
    },
    get_security_transition: {
      queryString: get_security_transition,
      createVars: (id: string): { id: string } => ({
        id,
      }),
    },
    get_currency_conversions: {
      queryString: get_currency_conversions,
      createVars: (
        page: number,
        per_page: number,
        type: OrderingType,
        direction: OrderingDirection,
        status: Status | 'all',
        ids: string[],
        account: string,
      ): {
        paginator: Paginator;
        order: ListingOrder;
        filter: ListingFilter;
      } => ({
        paginator: { page, per_page },
        order: { type, direction },
        filter: { status: status === 'all' ? [] : [status], ids, account },
      }),
    },
    get_currency_conversion: {
      queryString: get_currency_conversion,
      createVars: (id: string): { id: string } => ({
        id,
      }),
    },
    get_security_transfers: {
      queryString: get_security_transfers,
      createVars: (
        page: number,
        per_page: number,
        type: OrderingType,
        direction: OrderingDirection,
        status: Status | 'all',
        ids: string[],
        account: string,
      ): {
        paginator: Paginator;
        order: ListingOrder;
        filter: ListingFilter;
      } => ({
        paginator: { page, per_page },
        order: { type, direction },
        filter: { status: status === 'all' ? [] : [status], ids, account },
      }),
    },
    get_security_transfer: {
      queryString: get_security_transfer,
      createVars: (id: string): { id: string } => ({
        id,
      }),
    },
    get_money_transfers: {
      queryString: get_money_transfers,
      createVars: (
        page: number,
        per_page: number,
        type: OrderingType,
        direction: OrderingDirection,
        status: Status | 'all',
        ids: string[],
        account: string,
      ): {
        paginator: Paginator;
        order: ListingOrder;
        filter: ListingFilter;
      } => ({
        paginator: { page, per_page },
        order: { type, direction },
        filter: { status: status === 'all' ? [] : [status], ids, account },
      }),
    },
    get_money_transfer: {
      queryString: get_money_transfer,
      createVars: (id: string): { id: string } => ({
        id,
      }),
    },
  },
  mutations: {
    update_user_password: {
      mutationString: update_user_password,
      createVars: (old_password: string, new_password: string): { input: UpdateUserPassword } => ({
        input: { old_password, new_password },
      }),
    },
    accept_terms_of_use: {
      mutationString: accept_terms_of_use,
      createVars: (term_id: number): { input: number } => ({
        input: term_id,
      }),
    },
    read_notification: {
      mutationString: read_notification,
      createVars: (id: number): { input: number } => ({
        input: id,
      }),
    },
    read_message: {
      mutationString: read_message,
      createVars: (id: number): { input: number } => ({
        input: id,
      }),
    },
    accept_message: {
      mutationString: accept_message,
      createVars: (id: number): { input: number } => ({
        input: id,
      }),
    },
    update_user_timeout: {
      mutationString: update_user_timeout,
      createVars: (timeout: number): { input: number } => ({
        input: timeout,
      }),
    },
    update_user_language: {
      mutationString: update_user_language,
      createVars: (language: string): { input: string } => ({
        input: language,
      }),
    },
    logout: {
      mutationString: logout,
    },
    update_user_password_with_confirm: {
      mutationString: update_user_password_with_confirm,
      createVars: (old_password: string, new_password: string): { input: UpdateUserPassword } => ({
        input: { old_password, new_password },
      }),
    },
    confirm_password_update: {
      mutationString: confirm_password_update,
      createVars: (first_token: string, secret: string): { input: AuthSecond } => ({
        input: { first_token, secret },
      }),
    },
    create_exchange_order: {
      mutationString: create_exchange_order,
      createVars: (input: CreateExchangeOrder): { input: CreateExchangeOrder } => ({
        input,
      }),
    },
    create_exchange_order_confirm: {
      mutationString: create_exchange_order_confirm,
      createVars: (secret: string, token: string): { secret: string; token: string } => ({
        secret,
        token,
      }),
    },
    cancel_exchange_order: {
      mutationString: cancel_exchange_order,
      createVars: (id: number): { id: number } => ({
        id,
      }),
    },
    cancel_exchange_order_confirm: {
      mutationString: cancel_exchange_order_confirm,
      createVars: (secret: string, token: string): { secret: string; token: string } => ({
        secret,
        token,
      }),
    },
  },
  subscriptions: {
    new_token: {
      subscriptionString: new_token,
    },
    new_notification: {
      subscriptionString: new_notification,
    },
    notification_unread_count: {
      subscriptionString: notification_unread_count,
    },
    auto_read_notification: {
      subscriptionString: auto_read_notification,
    },
    new_message: {
      subscriptionString: new_message,
    },
    message_unread_count: {
      subscriptionString: message_unread_count,
    },
    message_read: {
      subscriptionString: message_read,
    },
    notification_read: {
      subscriptionString: notification_read,
    },
    sum_portfolio: {
      subscriptionString: sum_portfolio_subscription,
    },
    new_exchange_order: {
      subscriptionString: new_exchange_order,
    },
    update_exchange_order: {
      subscriptionString: update_exchange_order,
    },
    new_unit_order: {
      subscriptionString: new_unit_order,
    },
    update_unit_order: {
      subscriptionString: update_unit_order,
    },
    new_money_transition: {
      subscriptionString: new_money_transition,
    },
    update_money_transition: {
      subscriptionString: update_money_transition,
    },
    new_security_transition: {
      subscriptionString: new_security_transition,
    },
    update_security_transition: {
      subscriptionString: update_security_transition,
    },
    new_currency_conversion: {
      subscriptionString: new_currency_conversion,
    },
    update_currency_conversion: {
      subscriptionString: update_currency_conversion,
    },
    new_security_transfer: {
      subscriptionString: new_security_transfer,
    },
    update_security_transfer: {
      subscriptionString: update_security_transfer,
    },
    new_money_transfer: {
      subscriptionString: new_money_transfer,
    },
    update_money_transfer: {
      subscriptionString: update_money_transfer,
    },
  },
};
